import { Seo } from '../components/Seo';
import { Icon } from '../components/Icon';
import { HowItWorksSteps, CtaSection, FaqList } from '../components/Sections';
import { useT } from '../i18n';
import { buildTitle } from '../lib/site';

export function HowItWorksPage() {
  const t = useT();
  const p = t.pages.howItWorks;
  return (
    <>
      <Seo
        title={buildTitle(p.title)}
        description={p.lead}
        path="/how-it-works"
      />

      <section className="page-header">
        <div className="container">
          <span className="eyebrow">{p.eyebrow}</span>
          <h1>{p.title}</h1>
          <p>{p.lead}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <HowItWorksSteps />
        </div>
      </section>

      <section className="section" style={{ background: 'linear-gradient(180deg, transparent, rgba(245,181,68,0.02), transparent)' }}>
        <div className="container container-narrow">
          {p.detail.map((s, i) => (
            <div key={i} style={{ marginBottom: 56, display: 'grid', gridTemplateColumns: '80px 1fr', gap: 28 }}>
              <div className="step-num" style={{ margin: 0 }}>{i + 1}</div>
              <div>
                <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 28, color: 'var(--text-strong)', letterSpacing: '-0.025em', marginBottom: 12 }}>
                  {s.title}
                </h2>
                <p style={{ color: 'var(--text-muted)', fontSize: 16, lineHeight: 1.7, marginBottom: 16 }}>{s.body}</p>
                <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {s.points.map((pt) => (
                    <li key={pt} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', color: 'var(--text)' }}>
                      <Icon name="check" width={18} height={18} style={{ color: 'var(--mint)', marginTop: 3, flexShrink: 0 }} />
                      <span>{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="container container-narrow">
          <div className="section-head center">
            <span className="eyebrow">{p.faqEyebrow}</span>
            <h2>{p.faqTitle}</h2>
          </div>
          <FaqList limit={4} />
        </div>
      </section>

      <CtaSection />
    </>
  );
}
